module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 5-f7df3373ca5415c6c1cc4705128f2e46.jpg";